function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 24,
  height: 24,
  fill: "#D9D9D9"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4137_8909)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.6462 16.8539L16.3539 16.1462L12.5 12.2919V7.5H11.5V12.7077L15.6462 16.8539ZM12.0034 21.5C10.7588 21.5 9.58872 21.2638 8.4931 20.7915C7.39748 20.3192 6.44444 19.6782 5.63397 18.8685C4.82352 18.0588 4.18192 17.1066 3.70915 16.012C3.23638 14.9174 3 13.7479 3 12.5034C3 11.2588 3.23616 10.0887 3.70848 8.9931C4.18081 7.89748 4.82183 6.94444 5.63153 6.13398C6.44123 5.32353 7.39337 4.68192 8.48795 4.20915C9.58255 3.73638 10.7521 3.5 11.9966 3.5C13.2412 3.5 14.4113 3.73616 15.5069 4.20847C16.6025 4.68081 17.5556 5.32182 18.366 6.13152C19.1765 6.94122 19.8181 7.89337 20.2908 8.98795C20.7636 10.0826 21 11.2521 21 12.4966C21 13.7412 20.7638 14.9113 20.2915 16.0069C19.8192 17.1025 19.1782 18.0556 18.3685 18.866C17.5588 19.6765 16.6066 20.3181 15.512 20.7909C14.4174 21.2636 13.2479 21.5 12.0034 21.5ZM12 20.5C14.2167 20.5 16.1042 19.7208 17.6625 18.1625C19.2208 16.6042 20 14.7167 20 12.5C20 10.2833 19.2208 8.39583 17.6625 6.8375C16.1042 5.27917 14.2167 4.5 12 4.5C9.78333 4.5 7.89583 5.27917 6.3375 6.8375C4.77917 8.39583 4 10.2833 4 12.5C4 14.7167 4.77917 16.6042 6.3375 18.1625C7.89583 19.7208 9.78333 20.5 12 20.5Z",
  fill: "var(--n-color-text-subtle)"
}));

function SvgIconClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4137_8909",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _ref), _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.edaf6e65365add62d92f6f138e1f85a4.svg";
export { ForwardRef as ReactComponent };